import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-srs-disclaimer',
  templateUrl: './srs-disclaimer.component.html',
  styleUrls: ['../../../../styles.scss','./srs-disclaimer.component.scss']
})
export class SrsDisclaimerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
